import React from 'react';
import classNames from 'classnames';

import css from './IconCancel.module.css';

/**
 * Cancel/close icon supplied by design, standardised to the site's icon
 * weight: currentColor stroke, width 2 on the 24 grid, round caps. Defaults
 * to 14px; size via rootClassName.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 */
const IconCancel = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085"></path>
    </svg>
  );
};

export default IconCancel;
